import React, { useEffect, useState } from 'react';
import './index.css';

const StudentJoiningStatus = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [filteredEnquiries, setFilteredEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [joinedCount, setJoinedCount] = useState(0);
  const [notJoinedCount, setNotJoinedCount] = useState(0);
  const [statusFilter, setStatusFilter] = useState('all');
  const [dateFilter, setDateFilter] = useState('today');
  const [councillorFilter, setCouncillorFilter] = useState('all');
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().slice(0, 10);
  });
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [employees, setEmployees] = useState([]);
  const center = localStorage.getItem('center');
  const api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchEnquiries = async () => {
      const token = localStorage.getItem("jwt_token");
      if (!token) {
        setError(new Error("User not authenticated"));
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${api}/enquiries`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          const text = await response.text();
          throw new Error(text || 'Failed to fetch enquiries');
        }

        const data = await response.json();
        const filteredData = data.filter(item => item.centerName === center);
        setEnquiries(filteredData);
        setFilteredEnquiries(filteredData);
        setLoading(false);
      } catch (err) {
        console.error("Fetch error:", err);
        setError(err);
        setLoading(false);
      }
    };
    fetchEnquiries();
  }, [api, center]);

  useEffect(() => {
    filterEnquiries();
    fetchEmployees();
  }, [statusFilter, dateFilter, selectedDate, startDate, endDate, councillorFilter]);

  const fetchEmployees = async () => {
    const token = localStorage.getItem("jwt_token");
    if (!token) {
      console.error("JWT token not found");
      return;
    }

    try {
      const response = await fetch(`${api}/employees`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || "Failed to fetch employees");
      }

      const data = await response.json();

      const filteredData = data.employees.filter(
        (employee) => employee.center === center && employee.role === 'Councillor'
      );

      setEmployees(filteredData);
    } catch (err) {
      console.error("Error fetching employees:", err.message);
    }
  };

  const filterEnquiries = () => {
    let filtered = enquiries;

    if (statusFilter !== 'all') {
      filtered = filtered.filter(enquiry => enquiry.status === statusFilter);
    }

    if (councillorFilter !== 'all') {
      filtered = filtered.filter(enquiry => enquiry.counselorName.toLowerCase() === councillorFilter);
    }

    if (dateFilter === 'today') {
      const today = new Date();
      filtered = filtered.filter(enquiry => new Date(enquiry.date).toDateString() === today.toDateString());
    } else if (dateFilter === 'selected') {
      filtered = filtered.filter(enquiry => new Date(enquiry.date).toISOString().slice(0, 10) === selectedDate);
    } else if (dateFilter === 'yesterday') {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      filtered = filtered.filter(enquiry => new Date(enquiry.date).toDateString() === yesterday.toDateString());
    } else if (dateFilter === 'lastMonth') {
      const today = new Date();
      const lastMonth = new Date(today);
      lastMonth.setMonth(lastMonth.getMonth() - 1);
      filtered = filtered.filter(enquiry => new Date(enquiry.date) >= lastMonth && new Date(enquiry.date) <= today);
    } else if (dateFilter === 'all') {
      // no filter
    }

    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      filtered = filtered.filter(enquiry => new Date(enquiry.date) >= start && new Date(enquiry.date) <= end);
    }

    setFilteredEnquiries(filtered);
    const joined = filtered.filter(enquiry => enquiry.status === 'joined').length;
    const notJoined = filtered.length - joined;
    setJoinedCount(joined);
    setNotJoinedCount(notJoined);
  };

  if (loading) {
    return <p className="studentJoinStatus-loading">Loading...</p>;
  }

  if (error) {
    return <p className="studentJoinStatus-error">Error: {error.message}</p>;
  }

  return (
    <div className="studentJoinStatus-container">
      <div className="studentJoinStatus-filters">
        <select className="studentJoinStatus-filter" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
          <option value="all">All</option>
          <option value="joined">Joined</option>
          <option value="notJoined">Not Joined</option>
        </select>
        <select className="studentJoinStatus-filter" value={dateFilter} onChange={e => setDateFilter(e.target.value)}>
          <option value="today">Today</option>
          <option value="selected">Select Date</option>
          <option value="all">All</option>
          <option value="yesterday">Yesterday</option>
          <option value="lastMonth">Last Month</option>
        </select>
        {dateFilter === 'selected' && (
          <input className="studentJoinStatus-filter" type="date" value={selectedDate} onChange={e => setSelectedDate(e.target.value)} />
        )}
        <select className="studentJoinStatus-filter" value={councillorFilter} onChange={(e) => setCouncillorFilter(e.target.value)}>
          <option value="all">All</option>
          {employees.map(e =>(
            <option value = {e.username.toLowerCase()} key = {e._id}>{e.username}</option>
          ))}
        </select>
        <input className="studentJoinStatus-filter" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        <input className="studentJoinStatus-filter" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
      </div>
      <div className="studentJoinStatus-counts">
        <p style={{ color: 'green' }}>Joined: {joinedCount}</p>
        <p style={{ color: 'red' }}>Not Joined: {notJoinedCount}</p>
      </div>
      <table className="studentJoinStatus-table">
        <thead>
          <tr>
            <th className="studentJoinStatus-th">Student Name</th>
            <th className="studentJoinStatus-th">Course Name</th>
            <th className='studentJoinStatus-th'>Counselor Name</th>
            <th className="studentJoinStatus-th">Phone Number</th>
          </tr>
        </thead>
        <tbody>
          {filteredEnquiries.map((enquiry, index) => (
            <tr
              key={index}
              className={`studentJoinStatus-tr ${
                enquiry.status === 'joined' ? 'studentJoinStatus-joined' : 'studentJoinStatus-notJoined'
              }`}
            >
              <td className="studentJoinStatus-td">{enquiry.name}</td>
              <td className="studentJoinStatus-td">{enquiry.coursePreferred}</td>
              <td className = "studentJoinStatus-td">{enquiry.counselorName}</td>
              <td className="studentJoinStatus-td">{enquiry.mobile}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  // function handleRemark(id) {
  //   console.log(`Remark button clicked for enquiry ID: ${id}`);
  //   // Add your logic here for handling remarks
  // }
};

export default StudentJoiningStatus;
